import { REHYDRATE } from 'redux-persist';
import * as types from '../actions/types';
const WEALTH_RECOMMENDATION_TYPES = [
    'FINISH_INVEST_SETUP',
    'FINISH_SAVE_SETUP',
];
const isWealthRecommendation = (recommendation) => WEALTH_RECOMMENDATION_TYPES.includes(recommendation.type);
const initialState = {
    recommendations: [],
    wealthRecommendations: [],
};
const recommendations = (state = initialState, action) => {
    switch (action.type) {
        case REHYDRATE: {
            const recommendations = action.payload?.recommendations;
            if (recommendations)
                return { ...initialState };
            return state;
        }
        case types.GET_RECOMMENDATIONS_SUCCESS: {
            const recommendations = [];
            const wealthRecommendations = [];
            action.payload.recommendations.forEach((recommendation) => {
                if (isWealthRecommendation(recommendation)) {
                    // The card needs both to render
                    if (recommendation.data?.heading && recommendation.data?.text) {
                        wealthRecommendations.push(recommendation);
                    }
                }
                else {
                    recommendations.push(recommendation);
                }
            });
            return { ...state, recommendations, wealthRecommendations };
        }
        case types.DISMISS_RECOMMENDATIONS_REQUEST: {
            const { id } = action.extra;
            return {
                ...state,
                recommendations: state.recommendations.filter((r) => r.id !== id),
                wealthRecommendations: state.wealthRecommendations.filter((r) => r.id !== id),
            };
        }
        case types.LOGGED_OUT: {
            return initialState;
        }
        default:
            return state;
    }
};
export default recommendations;
